import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import {
  IAddMaterialGoodsIssueItem,
  IUpdateMaterialGoodsIssueItem,
  MaterialGoodsIssueItem,
} from "./material-goods-issue-item";

export const MaterialGoodsIssue = types
  .compose(
    Base,
    types.model({
      issueDate: types.maybeNull(types.string),
      items: types.optional(types.array(MaterialGoodsIssueItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IMaterialGoodsIssue
  extends Instance<typeof MaterialGoodsIssue> {}
export interface IMaterialGoodsIssueProperties
  extends SnapshotIn<typeof MaterialGoodsIssue> {}

export interface IAddMaterialGoodsIssue
  extends Omit<IMaterialGoodsIssueProperties, keyof IBase> {
  items: IAddMaterialGoodsIssueItem[];
}

export interface IUpdateMaterialGoodsIssue
  extends Omit<IMaterialGoodsIssueProperties, "items"> {
  items: IUpdateMaterialGoodsIssueItem[];
}
